import React from "react";
import { withRouter } from "react-router-dom";

function CompletedandWaiting(props) {
  return (
    <div className="row pt-4 pb-3">
      <div className="col-12">
        <button
          onClick={() => {
            props.history.push(
              "/dashboard/my-requests/confirm-complete/" +
                props.match.params.requestId
            );
          }}
          className="custom-buton custom-buton-large w-100"
        >
          Confirm move and release money
        </button>
      </div>
    </div>
  );
}

export default withRouter(CompletedandWaiting);
